import { useDispatch } from "react-redux";
import services from "../services/servicesTeso";
import {
  onLogin,
  onLogout,
  upDataSistemas,
  setEstadoCargandoTrue,
  setEstadoCargandoFalse,
} from "../store";

import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";



export const useSistema = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkAuthToken = async () => {
    const token2 = sessionStorage.getItem("token");
    const token = localStorage.getItem("token");
    if (!token && !token2) return dispatch(onLogout());

    try {
      const nombre = sessionStorage.getItem("Name") || "";
      const usuario = sessionStorage.getItem("payload") || "";

      localStorage.setItem("Name", nombre);
      localStorage.setItem("payload", usuario);
      localStorage.setItem("token", token2 || "");
      localStorage.setItem("token-init-date", String(new Date().getTime()));

      dispatch(onLogin({ name: nombre, uid: usuario }));
    } catch (error) {
      localStorage.clear();
      dispatch(onLogout());
    }
  };

  const filtrarSistemasJsonPorRol = async (
    systemsFromJson: any[],
    tokenPermisos: string
  ) => {
    if (!tokenPermisos) return [];

    const headers = {
      "Content-Type": "application/json",
      Authorization: tokenPermisos,
    };

    const checks = await Promise.all(
      systemsFromJson.map(async (sys) => {
        try {
          const sistemaId = sys?.sis_id;
          if (sistemaId === undefined || sistemaId === null) return null;

          const { data } = await axios.post(
            services.API.PermisoSistemaPagos.ApiUsuarios_ConsultaRol,
            { sistemaId },
            { headers }
          );

          return data?.resultado === "1" ? sys : null;
        } catch {
          return null;
        }
      })
    );

    return checks.filter(Boolean);
  };

  const DataSelectSistema = async () => {
    dispatch(setEstadoCargandoTrue());

    // ✅ Cargar JSON desde public/systems.json
    // const systemsFromJson = await cargarSystemsJson();

    const token = localStorage.getItem("token"); // ApiAutenticacion_Sistema_X_Usuario
    const tokenPermisos = localStorage.getItem("token2"); // ApiUsuarios_ConsultaRol
    const USER = localStorage.getItem("payload");

    await checkAuthToken();

    if (!token || !USER) {
      dispatch(setEstadoCargandoFalse());
      return;
    }

    try {
      const url =
        services.API.Sistema.ApiAutenticacion_Sistema_X_Usuario + "?USER=" + USER;

      const { data } = await axios.post(url, null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      const sistemasBase = Array.isArray(data?.sistemas) ? data.sistemas : [];

      // const sistemasPermitidosJson = await filtrarSistemasJsonPorRol(
      //   systemsFromJson,
      //   tokenPermisos || ""
      // );

      // ✅ Marcar como "viene del JSON" para la UI
      // const sistemasPermitidosJsonMarcados = sistemasPermitidosJson.map((s) => ({
      //   ...s,
      //   newMCP: true,
      // }));

      // const sistemasActualizados = [
      //   ...sistemasBase,
      //   ...sistemasPermitidosJsonMarcados,
      // ];

      dispatch(upDataSistemas({ sistemas: sistemasBase }));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron cargar los sistemas",
        footer: "",
      });
    } finally {
      dispatch(setEstadoCargandoFalse());
    }
  };

  return {
    DataSelectSistema,
  };
};
